import CloseIcon from '@mui/icons-material/Close';
import Star from '@mui/icons-material/Star';
import { DialogContent } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import ProjectWizardDialogContent from './wizard-dialog-demo-content';

import {
  WizardDialog,
  WizardDialogTitle,
} from '~/client/components/base/wizard-dialog';
import { QuickActionButton } from '~c/components/base/quick-action';

interface Props {
  className?: string;
}

const WizardDialogQuickAction: React.FC<Props> = ({ className }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={className}>
      <QuickActionButton icon={Star} onClick={handleOpen}>
        Launch wizard
      </QuickActionButton>
      <WizardDialog open={open} onClose={handleClose}>
        <WizardDialogTitle onBack={handleClose} isFirstStep isLastStep>
          Create your project
        </WizardDialogTitle>
        <DialogContent>
          <ProjectWizardDialogContent onSubmit={handleClose} />
        </DialogContent>
      </WizardDialog>
    </div>
  );
};

export default muiStyled(WizardDialogQuickAction)(({ theme }) => css``);
